
export class AutoPaySignUpBeanList {
    thirdPartyId: string
    primaryCustomerAgreementNumber: string
    primaryCustomerScheduleNumber: string
    effectiveDate: string
    bankAccountNum: string
    bankRoutingNum: string
    accountName: string
    billingId:string
    finAcctType: string
    bankName: string
    autoInvoiceFlag: string
    email: string
}
